import axios from 'axios'


const AxiosTestService = {}

AxiosTestService.getPosts = () => {
  return axios.get('https://jsonplaceholder.typicode.com/posts')
}

export default AxiosTestService